import React from 'react';
import PropTypes from 'prop-types';
import { compact } from 'lodash';

import { Divider, Icon, Text } from 'base-components';
import { Row, Column } from 'styled-components-reactive-grid';

import { getUnits } from 'utils/unit';

import WeatherBadge from './WeatherBadge';

export default function SearchInputWeatherSummary({
  isHover,
  isVisible,
  unit,
  weather,
}) {
  const {
    current: { code, summary, temperature },
  } = weather;
  const { temperatureUnitLabel } = getUnits(unit);

  return (
    <Column modifiers={['height_100', 'padScaleY_0']}>
      <Row modifiers={['height_100', 'middle']}>
        <Column modifiers={['height_100', 'padScaleX_0', 'padScaleY_2']}>
          <Divider modifiers={['vertical']} />
        </Column>
        <Column modifiers={['col', 'padScaleY_0']}>
          <Row>
            <Column modifiers={['col', 'end', 'padScaleY_0']}>
              <Text modifiers={['small', 'textLight']}>{summary}</Text>
            </Column>
          </Row>
          <Row>
            <Column modifiers={['col', 'end', 'padScaleY_0']}>
              <Text>
                {`${Math.round(temperature)}º`}
                {temperatureUnitLabel}
              </Text>
            </Column>
          </Row>
        </Column>
        <Column modifiers={['center']}>
          <WeatherBadge name={code} />
        </Column>
        <Column modifiers={['center']}>
          <Icon
            name={isVisible ? 'chevron-up' : 'chevron-down'}
            modifiers={compact(['mini', isHover && 'info'])}
          />
        </Column>
      </Row>
    </Column>
  );
}

SearchInputWeatherSummary.propTypes = {
  isHover: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  unit: PropTypes.string.isRequired,
  weather: PropTypes.shape({
    current: PropTypes.shape({
      code: PropTypes.string,
      summary: PropTypes.string,
      temperature: PropTypes.number,
    }).isRequired,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/SearchInput/LocationTimeAndWeather/SearchInputWeatherSummary.js